import { VariantProps, cva } from 'class-variance-authority';
import { CommonProps } from '../../types';
import { twMerge } from 'tailwind-merge';
import { Heading, Text } from '../../';
import type { GASeatInfo, SeatInfo } from '@beat-venues/common-types';

import type { JSX } from 'react';

export interface SeatProps
    extends CommonProps,
        VariantProps<typeof SeatStyles> {
    seats: SeatInfo[];
    gaSeats?: GASeatInfo[];
    isModal: boolean;
    levelTitle: string;
    blockTitle: string;
    rowTitle: string;
    seatTitle: string;
    title?: string;
    noSeatLabel?: string;
}

export const SeatStyles = cva('w-full md:w-1/2');

export const Seat = ({
    seats,
    gaSeats,
    isModal,
    levelTitle,
    blockTitle,
    rowTitle,
    seatTitle,
    title,
    className,
    noSeatLabel,
    testId = 'seat',
}: SeatProps): JSX.Element => {
    return (
        <div
            data-testid={testId}
            className={twMerge(SeatStyles({ className }))}
        >
            {title && (
                <Heading
                    as="h3"
                    className={`${
                        !seats?.length && gaSeats?.length
                            ? 'xl:block'
                            : 'xl:hidden'
                    } ${isModal ? 'mt-12 xl:mt-24' : ''}`}
                    size="h5"
                >
                    {title}
                </Heading>
            )}
            {seats && seats.length > 0 && (
                <table className="w-full table-auto uppercase">
                    <thead
                        className={`sticky top-0 text-center ${
                            !isModal ? 'bg-gray-500' : ''
                        }`}
                    >
                        <tr>
                            <th scope="col" className="text-left">
                                {levelTitle}
                            </th>
                            <th scope="col">{blockTitle}</th>
                            <th scope="col">{rowTitle}</th>
                            <th scope="col">{seatTitle}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {seats &&
                            seats.map((seat, index) => (
                                <tr
                                    key={`${index}-${seat.section}`}
                                    className="text-center"
                                >
                                    <td className="text-left capitalize">
                                        {seat.level}
                                    </td>
                                    <td>{seat.section}</td>
                                    <td>{seat.row}</td>
                                    <td>{seat.seat}</td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            )}
            {gaSeats &&
                gaSeats.length > 0 &&
                gaSeats.map((ga) => (
                    <div>
                        <Text>
                            {ga.count} &times; {ga.level}
                        </Text>
                    </div>
                ))}
            {(!seats || seats.length === 0 || !seats[0].seat) &&
                (!gaSeats || gaSeats.length === 0 || !gaSeats[0].level) && (
                    <Text>{noSeatLabel}</Text>
                )}
        </div>
    );
};
